import React from 'react';
import { Box, xcss, Text, media } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import {
	FireScreenAnalytics,
	ContextualAnalyticsData,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import type { ImportType } from '../../common/constants/import-type';
import { X2C_SCREENS } from '../../common/constants/metrics';
import { CROSS_FLOW } from '../../common/constants/source';
import type { ImporterFlow } from '../../common/types';
import { useSource } from '../../controllers/import-state/selectors';
import messages from './messages';
import { SourceSection } from './source-section';

type SelectSourceScreenProps = {
	onNext: (importType?: ImportType, supportedFlow?: ImporterFlow) => void;
};

export const SelectSourceScreen = ({ onNext }: SelectSourceScreenProps) => {
	const { formatMessage } = useIntl();
	const [source] = useSource();
	const skipSourceSelection = source === CROSS_FLOW;

	return (
		<ContextualAnalyticsData sourceName={X2C_SCREENS.SELECT_SOURCE_SCREEN} sourceType={SCREEN}>
			<Box
				xcss={wrapperStyles}
				testId="project-create-importer-upload-flow.ui.select-source-screen.wrapper"
			>
				{!skipSourceSelection && (
					<Box xcss={headingWrapperStyles}>
						<Box xcss={pageHeadingStyles}>{formatMessage(messages.heading)}</Box>
						<Text as="p">{formatMessage(messages.pageDescription)}</Text>
					</Box>
				)}
				<SourceSection onNext={onNext} skipSourceSelection={skipSourceSelection} />
				<FireScreenAnalytics />
			</Box>
		</ContextualAnalyticsData>
	);
};

const wrapperStyles = xcss({
	padding: 'space.600',
	backgroundColor: 'elevation.surface',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderLeft: `solid 1px ${token('color.border', colors.N30)}`,
	width: '100%',
	overflowY: 'auto',
	[media.above.lg]: {
		paddingInline: 'space.1000',
	},
});

const headingWrapperStyles = xcss({
	marginTop: 'space.300',
	marginBottom: 'space.100',
});

const pageHeadingStyles = xcss({
	font: token('font.heading.large'),
	marginBottom: 'space.300',
});
